import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Card, Button } from "react-bootstrap";

function MainContent(props) {
  const [products, setProducts] = useState(props.allProducts);
  const [noitem, setNoitem] = useState(false);

  useEffect(() => {
    const data = props.allProducts.filter((item) => {
      const title = props.match.params.querry
        ? item.title
            .toLowerCase()
            .indexOf(props.match.params.querry.toLowerCase()) !== -1
        : true;
      const sub_category = props.match.params.querry
        ? item.sub_category
            .toLowerCase()
            .indexOf(props.match.params.querry.toLowerCase()) !== -1
        : true;
      return title || sub_category;
    });
    if (data.length === 0) {
      setNoitem(true);
    } else {
      setNoitem(false);
    }
    setProducts(data);
  }, [props]);

  const handelView = (id) => {
    props.history.push(`/detail/${id}`);
  };

  return (
    <div className="container row mx-auto my-5">
      {noitem ? (
        <div className="text-center fw-bold h5">No Item Found</div>
      ) : (
        products.map((item, i) => {
          return (
            <div key={item.id} className="col-md-6 col-lg-4 col-12 mb-3 ">
              <Card
                className="shadow-lg mx-auto"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  backgroundColor: "#f4f4f4",
                }}
              >
                <div className="row align-items-center">
                  <div className="col-4 col-sm-12 d-flex shadow-sm justify-content-center ps-3 ps-sm-0">
                    <img
                      className="img-fluid py-4 my_img"
                      src={item.image}
                      style={{
                        backgroundColor: "#f4f4f4",
                      }}
                      alt="..."
                    />
                  </div>
                  <div className="col-8 col-sm-12 px-4 my-3">
                    <p>{item.title}</p>
                    <p>
                      <span className="fw-bold">
                        Price: Rs.
                        {item.discounted_price}
                      </span>{" "}
                      &nbsp;
                      <span
                        className="text-decoration-line-through text-muted"
                        style={{ fontSize: "12px" }}
                      >
                        Rs.{item.selling_price}
                      </span>
                    </p>
                    <div className="d-md-flex justify-content-between">
                      {props.cart.find(
                        (citem) => Number(citem.id) === Number(item.id)
                      ) ? (
                        <Button
                          variant="dark"
                          className="p-1 p-sm-2"
                          onClick={() => {
                            props.removeFromCart(item.id);
                          }}
                        >
                          Remove From Cart
                        </Button>
                      ) : (
                        <Button
                          variant="dark"
                          className="p-1 p-sm-2"
                          onClick={() => {
                            props.addToCart(item);
                          }}
                        >
                          Add To Cart
                        </Button>
                      )}
                      <Button
                        variant="dark"
                        className="p-1 p-sm-2 ms-1"
                        onClick={(e) => {
                          handelView(item.id);
                        }}
                      >
                        View
                      </Button>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          );
        })
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allProducts: state.products,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (val) => dispatch({ type: "ADD_TO_CART", payload: val }),
    removeFromCart: (val) =>
      dispatch({ type: "REMOVE_FROM_CART", payload: val }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
